/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.4 4.8H1.2a1.2 1.2 0 1 1 0-2.4h1.2v2.4zM21.6 4.8h1.2a1.2 1.2 0 1 0 0-2.4h-1.2v2.4zM20.397 17.4v-15a2.4 2.4 0 0 0-2.4-2.4h-12a2.4 2.4 0 0 0-2.4 2.4v15h16.8zM3.596 20.4h16.8v-1.8h-16.8zM3.596 24h16.8v-2.4h-16.8z"
})), 'CategoryCM');